import { useEffect } from 'react';
import axios from 'axios';
import { clearAuth } from '../utils/authHelper';
import { isPublicStatusBrowseContext } from '../utils/publicStatusPage';

const isApiRequest = (url) => {
  if (!url || typeof url !== 'string') return false;
  try {
    const parsed = new URL(url, window.location.origin);
    return parsed.pathname.startsWith('/api/');
  } catch {
    return url.startsWith('/api/');
  }
};

/**
 * Global axios interceptor hook to handle authentication errors
 * Catches 401/403 errors and redirects to login after clearing auth data
 */
export const useAxiosInterceptor = () => {
  useEffect(() => {
    // Set up response interceptor to catch auth errors
    const interceptor = axios.interceptors.response.use(
      // On successful response, just return it
      (response) => response,
      
      // On error response, check for auth errors
      (error) => {
        const requestUrl = error?.config?.url;
        const isApiAuthFailure = isApiRequest(requestUrl);

        // Check if it's an auth error (401 Unauthorized or 403 Forbidden)
        if ((error.response?.status === 401 || error.response?.status === 403) && isApiAuthFailure) {
          const currentPath = window.location.pathname;

          // Don't redirect if already on auth pages to prevent redirect loops
          if (!currentPath.startsWith('/auth') &&
              !currentPath.startsWith('/invitation') &&
              !isPublicStatusBrowseContext()) {
            
            console.log('🔒 Authentication error detected, clearing auth and redirecting to login');
            
            // Clear all auth data
            clearAuth();
            
            // Redirect to login page (using window.location for global redirect)
            window.location.href = '/auth/login';
          }
        }
        
        // Always reject the promise so the original error handler can still process it
        return Promise.reject(error);
      }
    );

    // Cleanup: remove interceptor when component unmounts
    return () => {
      axios.interceptors.response.eject(interceptor);
    };
  }, []);
};
